export default function PatientTypeLeaderboard({ leaderboardInfo, setOpenPatientsLeaderboard, org }) {
  const handleClose = () => {
    setOpenPatientsLeaderboard(false);
  };
  
  const renderPercent = (seen, total) => {
    if (total === 0) return 0;
    return ((seen / total) * 100).toFixed(2);
  };

  return (
    <div className="fixed left-[20%] top-[5%] w-[60%] max-h-[90%] flex flex-col items-center justify-center bg-light-purple p-6 rounded-md shadow-md z-10">
      <button
        className="absolute right-[20px] top-[10px] hover:text-ktx-navy font-bold text-[26px]"
        onClick={handleClose}
      >
        ×
      </button>
      <h2 className="font-semibold text-[26px] mb-4">Provider Utilization Leaderboard for {org}</h2>

      <div className="w-full overflow-x-auto">
        <table className="w-full min-w-[800px]">
          <thead>
            <tr>
              <th className="border-b-2 border-b-ktx-purple p-3 text-left">Provider</th>
              <th className="border-b-2 border-b-ktx-purple p-3 text-center">Total (Seen/All)</th>
              <th className="border-b-2 border-b-ktx-purple p-3 text-center">New Patients</th>
              <th className="border-b-2 border-b-ktx-purple p-3 text-center">Follow-Ups</th>
              <th className="border-b-2 border-b-ktx-purple p-3 text-center">Misc</th>
            </tr>
          </thead>
          <tbody>
            {leaderboardInfo?.map((provider, index) => (
              <tr
                key={index}
                className="bg-white"
              >
                <td className="p-3 border-b border-gray-200">{provider.name}</td>
                <td className="p-3 border-b border-gray-200 text-center">
                  {provider.totalSeen}/{provider.total}
                  <span className="text-sm text-gray-600 ml-2">
                    ({renderPercent(provider.totalSeen, provider.total)}%)
                  </span>
                </td>
                <td className="p-3 border-b border-gray-200 text-center">
                  {provider.newPatientsSeen}/{provider.newPatients}
                  <span className="text-sm text-gray-600 ml-2">
                    ({renderPercent(provider.newPatientsSeen, provider.newPatients)}%)
                  </span>
                </td>
                <td className="p-3 border-b border-gray-200 text-center">
                  {provider.followUpPatientsSeen}/{provider.followUpPatients}
                  <span className="text-sm text-gray-600 ml-2">
                    ({renderPercent(provider.followUpPatientsSeen, provider.followUpPatients)}%)
                  </span>
                </td>
                <td className="p-3 border-b border-gray-200 text-center">
                  {provider.unallocatedPatientsSeen}/{provider.unallocatedPatients}
                  <span className="text-sm text-gray-600 ml-2">
                    ({renderPercent(provider.unallocatedPatientsSeen, provider.unallocatedPatients)}%)
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}